import { useTransaction } from "../context/TransactionContext";
import "../styles/transactionModal.css";

const TransactionModal = () => {
  const { showModal, txInfo, closeTransactionModal } = useTransaction();

  if (!showModal || !txInfo) return null;

  const { recipient, amount, asset, feeAlgo, feeProject, onConfirm } = txInfo;

  const networkFee = feeAlgo ?? 0.001;
  const projectFee = feeProject ?? (typeof asset === "string" ? 0 : 0);

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <h2>Confirmar Transacción</h2>

        <h3>
          <strong>Destino:</strong> {recipient.slice(0, 4)}...{recipient.slice(-4)}
        </h3>

        <h3>
          <strong>Valor servicio:</strong> {amount.toFixed(2)}{" "}
          {typeof asset === "string" ? "ALGO" : asset.name}
        </h3>

        {typeof asset !== "string" && (
          <h3>
            <strong>Mox Fee:</strong> {projectFee.toFixed(2)} {asset.name}
          </h3>
        )}

        <h3>
          <strong>Algo Fee:</strong> {networkFee.toFixed(3)} ALGO
        </h3>

        <h3>
          <strong>Total servicio:</strong>
          <ul style={{ paddingLeft: "1rem", listStyle: "none" }}>
            {typeof asset !== "string" && (
              <li>
                <strong>= -{(amount + projectFee).toFixed(2)} {asset.name}</strong>
              </li>
            )}
            <li>- {networkFee.toFixed(3)} ALGO</li>
          </ul>
        </h3>

        <div className="modal-actions">
          <button
            onClick={() => {
              onConfirm();
              closeTransactionModal();
            }}
            className="button-primary"
          >
            Confirmar
          </button>
          <button onClick={closeTransactionModal} className="button-secondary">
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default TransactionModal;


